import { ProductType } from './types/product'

const environment = process.env.NEXT_PUBLIC_ENVIRONMENT ?? 'development'

export const bff = process.env.NEXT_PUBLIC_BFF_URL

export const sanityProjectId = process.env.NEXT_PUBLIC_SANITY_PROJECT_ID

export const sanityDataset = process.env.NEXT_PUBLIC_SANITY_DATASET

export const sanityApiVersion = process.env.NEXT_PUBLIC_SANITY_API_VERSION

export const isProduction = environment === 'production'

export const isPreproduction = environment === 'preproduction'

export const googleMapsApiKey = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY ?? ''

export const stripeKey = process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY ?? ''

export const baseUrl = process.env.NEXT_PUBLIC_BASE_URL

export const bookableHours: Record<ProductType, Record<string, number>> = {
  meeting_room: {
    min: parseInt(process.env.NEXT_PUBLIC_MEETING_ROOM_MIN_BOOKABLE_HOUR ?? '9'),
    max: parseInt(process.env.NEXT_PUBLIC_MEETING_ROOM_MAX_BOOKABLE_HOUR ?? '17'),
  },
  event_space: {
    min: parseInt(process.env.NEXT_PUBLIC_GATHER_SPACE_MIN_BOOKABLE_HOUR ?? '7'),
    max: parseInt(process.env.NEXT_PUBLIC_GATHER_SPACE_MAX_BOOKABLE_HOUR ?? '20'),
  },
  day_pass: {
    min: parseInt(process.env.NEXT_PUBLIC_HOT_DESK_MIN_BOOKABLE_HOUR ?? '9'),
    max: parseInt(process.env.NEXT_PUBLIC_HOT_DESK_MAX_BOOKABLE_HOUR ?? '17'),
  },
  office: {
    min: parseInt(process.env.NEXT_PUBLIC_OFFICE_MIN_BOOKABLE_HOUR ?? '9'),
    max: parseInt(process.env.NEXT_PUBLIC_OFFICE_MAX_BOOKABLE_HOUR ?? '17'),
  },
  suite: {
    min: parseInt(process.env.NEXT_PUBLIC_SUITE_MIN_BOOKABLE_HOUR ?? '9'),
    max: parseInt(process.env.NEXT_PUBLIC_SUITE_MAX_BOOKABLE_HOUR ?? '17'),
  },
}

export const defaultBookableDays = parseInt(process.env.NEXT_PUBLIC_DEFAULT_BOOKABLE_DAYS ?? '180')
export const defaultBuildingName = 'the-spiral'

export const cookieDomainScriptId = process.env.NEXT_PUBLIC_COOKIE_DOMAIN_SCRIPT_ID

export const clarityProjectId = process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID

export const contactFormStartedSessionItem = 'contactFormStarted'
export const pricingFormStartedSessionItem = 'pricingFormStarted'
export const checkoutFormStartedSessionItem = 'checkoutFormStarted'

export const googleAnalyticsClientId = 'google_analytics_client_id'
export const defaultContactEmail = 'help@yourstudio.com'
export const hubspotEmailErrorMessage = 'Email address {email} is invalid'

export const subdomainPrefix = 'print'
